// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Vero Software components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import VeroNavbar from "components/VeroNavbar";
import VeroFooter from "components/VeroFooter";

// Page sections
import ProjectTimeline from "pages/Projects/components/ProjectTimeline";
import projectsData from "pages/Projects/data/projectsData";

// Routes
import routes from "routes";

function Projects() {
  return (
    <MKBox>
      <VeroNavbar routes={routes} />
      <MKBox component="section" py={6}>
        <Container>
          <Grid container justifyContent="center" textAlign="center" mb={4}>
            <Grid item xs={12} md={8}>
              <MKTypography variant="h3" mb={1}>
                Projects
              </MKTypography>
              <MKTypography variant="body1" color="text">
                A sample of the work we&apos;ve shipped &mdash; integrations, data platforms, and
                the AI/ML built on top of them.
              </MKTypography>
            </Grid>
          </Grid>
          <Grid container justifyContent="center">
            <Grid item xs={12} md={9} lg={8}>
              <ProjectTimeline items={projectsData} />
            </Grid>
          </Grid>
        </Container>
      </MKBox>
      <VeroFooter />
    </MKBox>
  );
}

export default Projects;
